angular.module('unergie.main')
.controller('pcesCtrl', ($scope, $location, $state, $stateParams, $filter, DownloadService, AccountService, AlertManager, DataAccess, DataAccessTags,
    AdminComments, PrmUtilsService, NgTableParams, TableGeneratorService, ApiUser, DataAccessSearch, DataAccessInvoices, BoFeaturesService,
    ModalService, ReferencesService, FilterMapping, OrganizationService, ErrorCatcher) => {
    // PRELOAD filter
    $filter('contractStatus')(0)

    const feats = BoFeaturesService.getModuleFeatures('accountinfo')
    $scope.isAIFeatureOn = (feature) => feats[feature]
    $scope.canSeeJira = BoFeaturesService.isFeatureOn('canSeeJira')
    $scope.jiraVDP = BoFeaturesService.isFeatureOn('jiraVDP')
    $scope.crossOrg = BoFeaturesService.isFeatureOn('crossOrg')
    $scope.canTransferContractToAccount = BoFeaturesService.isFeatureOn('canTransferContractToAccount')
    $scope.canChangeCategoryAccount = BoFeaturesService.isFeatureOn('canChangeCategoryAccount')

    $scope.isB2B = OrganizationService.isB2B

    const filterSearch = {}
    $scope.contract_status_mapping = FilterMapping.contractStatus

    $scope.contractsGas = {
        show: {},
        refreshing: false,
        columns: {
            'id': { label: 'Id', mode: 'search_wildcard', length: 9, mandatory: true },
            'brand': { label: 'Compte', mode: 'search_wildcard', mandatory: true },
            'id_pce': { label: 'PRM', mode: 'search_wildcard', length: 14 },
            'label': { label: 'Libellé', mode: 'search_wildcard' },
            'category.name': { label: 'Paquet facturier', mode: 'search_wildcard' },
            'status': { label: 'Statut', mode: 'search_operator', binding: 'technical_status' },
            'technical_status': { label: 'Statut', mode: 'hidden', hidden_search: 'search_operator' },
            'commissioning_date': { label: 'Date activation', mode: 'search_date' },
            'decommissioning_date': { label: 'Date résiliation', mode: 'search_date' },
            'id_account': { label: 'Id_account', mode: 'hidden' },
            'organization': { label: 'Organisation', mode: 'hidden' },
            'subscription_type': { label: 'Type souscription', mode: 'search_wildcard' },
            'pce.addr_street_number': { label: 'Numéro rue', mode: 'hidden' },
            'pce.addr_street_name': { label: 'Nom rue', mode: 'hidden' },
            'pce.addr_post_code': { label: 'Code postal', mode: 'hidden' },
            'pce.addr_city_lbl': { label: 'Code postal', mode: 'hidden' },
            'pce.reading_frequency': { label: 'Fréquence relève', mode: 'search_wildcard' },
            'pce.serial': { label: 'Matricule', mode: 'search_wildcard' },
            'pce.routing_tariff': { label: 'Tarif acheminement', mode: 'search_wildcard' },
            'pce.current_car': { label: 'CAR', mode: 'search_operator' },
            'pce.current_car_profile': { label: 'Profil', mode: 'search_wildcard' },
        },
    }

    if ($scope.crossOrg) {
        $scope.contractsGas.columns.organization = { label: 'Organisation', mode: 'search_wildcard' }
    }

    if ($stateParams.id_contract || $stateParams.brand || $stateParams.category || $stateParams.status) {
        $scope.contractsGas.instance = {}
        $scope.contractsGas.instance.page = () => 1
        $scope.contractsGas.instance.count = () => 25
        $scope.contractsGas.instance.sorting = () => ({})
        $scope.contractsGas.instance.filter = () => _.assign(_.clone($location.search()), _.pickBy({
            'id': $stateParams.id_contract,
            'category.name': $stateParams.category,
            'technical_status': $stateParams.status && [$stateParams.status],
        }))
    }

    $scope.refresh = () => {
        return TableGeneratorService.getTable($scope.contractsGas, 'vw-pces', 'category', null, filterSearch)
    }

    $scope.refresh()

    $scope.refreshContractData = function (c) {
        c.refreshingData = true
        return DataAccessSearch({}).searchPaginated({ resource: 'vw-pces', id: c.id, withRelated: 'account.technicalContact,category,technicalContact' }).$promise
        .then((contractResult) => {
            _.assign(c, (contractResult.results && contractResult.results[0]) || {})
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.refreshingData = false
        })
    }

    $scope.refreshContractInvoices = function (c) {
        c.refreshingInvoices = true
        return DataAccessInvoices.getContractInvoices({ id_contract: c.id }).$promise.then((contractInvoices) => {
            _.each(contractInvoices, (i) => {
                i.total = _.get(i, 'preparation_result.sumup.total')
            })
            c.invoicesTP = new NgTableParams({ count: 12 }, {
                counts: [],
                dataset: contractInvoices,
            }) }).catch(ErrorCatcher)
        .finally(() => {
            c.refreshingInvoices = false
        })
    }

    $scope.refreshContractTags = (c) =>
        DataAccessTags.contractTags({ id_contract: c.id }).$promise.then((contractTags) => {
            c.tags = contractTags
        }).catch(ErrorCatcher)


    $scope.refreshContract = function (c) {
        const refreshes = [
            $scope.refreshContractData(c),
            $scope.refreshContractTags(c),
            $scope.refreshContractInvoices(c),
        ]
        return Promise.all(refreshes).then(() => {
            c.fetched = true
        })
    }

    $scope.expandContract = function (contractGas) {
        if (!contractGas.refreshing) {
            contractGas.expanded = !contractGas.expanded
            if (!contractGas.fetched) {
                return $scope.refreshContract(contractGas)
            }
        }
    }

    // INFORMATION TAB
    // CONTACT
    $scope.contactFields = {
        civ: {
            label: 'Civilité',
            required: true,
            type: 'radio',
            enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }],
        },
        givenname: {
            label: 'Prénom',
            required: true,
            type: 'text',
        },
        sn: {
            label: 'Nom de famille',
            required: true,
            type: 'text',
        },
        phone: {
            label: 'Téléphone',
            required: true,
            type: 'phone-all',
        },
        email: {
            label: 'E-mail',
            required: true,
            type: 'email',
        },
    }

    $scope.updateTechnicalContactPayload = (contractGas) => {
        contractGas.updatedContact = angular.copy((contractGas.technicalContact && contractGas.technicalContact.length && contractGas.technicalContact[0]) || {})
    }

    $scope.saveTechnicalContact = function (contractGas) {
        contractGas.savingContact = true
        let p
        if (contractGas.updatedContact.id) {
            p = DataAccess.updateAdditionalContact({ id: contractGas.updatedContact.id }, contractGas.updatedContact).$promise
        } else {
            contractGas.updatedContact.type = 'TECHNICAL'
            p = DataAccess.addAdditionalContact({ id_contract: contractGas.id }, contractGas.updatedContact).$promise
        }
        return p.then(() => {
            AlertManager.success('Contact mis à jour')
            return $scope.refreshContractData(contractGas) }).catch(ErrorCatcher)
        .finally(() => {
            contractGas.savingContact = false
        })
    }

    $scope.openContractTransferModal = (c) => ModalService.openModal({ type: 'contractTransferModal', size: 'lg' }, { contract: c }, () => $scope.refreshContract(c))

    // TAGS
    $scope.tagRefBackup = []
    $scope.tagPayload = { id: '' }

    DataAccessTags.getRefContractTags().$promise.then((data) => {
        $scope.tagRefBackup = _.orderBy(data, 'id')
    }).catch(ErrorCatcher)

    $scope.filterContractTags = function (c) {
        const tagRef = []
        $scope.tagRefBackup.forEach((datum) => {
            if (!_.find(c.tags, { id_tag: datum.id })) {
                return tagRef.push({ value: datum.id, label: datum.text })
            }
        })
        c.tagFields = {
            id: {
                required: true,
                label: 'Nom',
                placeholder: 'Nom',
                type: 'select',
                enum: tagRef,
            },
        }
    }

    const resetTagPayload = function () {
        const tagTemplate = { id: '' }
        $scope.tagPayload = angular.copy(tagTemplate)
    }

    $scope.addTag = (c) =>
        DataAccessTags.addContractTag({ id_contract: c.id, id_tag: $scope.tagPayload.id }).$promise.then(() => {
            AlertManager.success('Tag ajouté')
            resetTagPayload()
            return $scope.refreshContractTags(c) }).catch(ErrorCatcher)


    $scope.deleteTag = (c, tag) =>
        DataAccessTags.delContractTag({ id: tag.id }).$promise.then(() => {
            AlertManager.success('Tag retiré')
            return $scope.refreshContractTags(c) }).catch(ErrorCatcher)


    // INLINE EDITION
    $scope.prevent = function (e) {
        e.preventDefault()
        return e.stopPropagation()
    }

    $scope.copied = function (e, objectName) {
        $scope.prevent(e)
        return AlertManager.success(`${objectName} copié !`)
    }

    // LABEL EDITION
    $scope.editLabelFields = {
        newLabel: {
            label: 'Libellé',
            type: 'text',
        },
    }

    $scope.toggleOnLabelEditing = function (c) {
        c.newLabel = c.label
        c.editLabel = true
    }

    $scope.toggleOffLabelEditing = (c) => {
        c.editLabel = false
    }

    $scope.updateLabel = (c) =>
        DataAccess.updateContractInfos({ id_contract: c.id }, { label: c.newLabel }).$promise.then(() => {
            AlertManager.success('Label mis à jour')
            c.editLabel = false
            c.label = c.newLabel
        }).catch(ErrorCatcher)


    // MASS ACTIONS

    $scope.toggleSelected = function (contractGas, e) {
        e.preventDefault()
        e.stopPropagation()
        contractGas.selected = !contractGas.selected
    }

    $scope.selectAll = () =>
        _.forEach($scope.contractsGas.instance.data, (c) => {
            c.selected = true
        })


    $scope.deSelectAll = () =>
        _.forEach($scope.contractsGas.instance.data, (c) => {
            c.selected = false
            return true
        })

    $scope.getSelectedNumber = () => _.countBy($scope.contractsGas.instance.data, 'selected').true || 0

    const contractTransitions = BoFeaturesService.getModuleFeatures('contractTransitions')
    const allowedTransitions = {}

    _.each(contractTransitions, (v, k) => {
        if (v) {
            const [from, to] = k.split('>')
            allowedTransitions[from] = allowedTransitions[from] || []
            allowedTransitions[from].push(to)
        }
    })

    $scope.changeStatus = {
        payloads: {
            status: null,
        },
        fields: {
            status: {
                label: 'Status',
                type: 'select',
                required: true,
                placeholder: 'Changement de status',
                enum: [],
            },
        },
        isEnabled(contractGas) {
            return _.keys(allowedTransitions).includes(`${contractGas.technical_status}`)
        },
        preparePopup(contractGas) {
            if (allowedTransitions[contractGas.technical_status]) {
                $scope.changeStatus.payloads = { status: allowedTransitions[contractGas.technical_status][0] }
                $scope.changeStatus.fields.status.enum = _.map(allowedTransitions[contractGas.technical_status], (s) => {
                    return {
                        value: s,
                        label: `${$filter('contractStatus')(contractGas.technical_status)} ➔ ${$filter('contractStatus')(s)}`,
                    }
                })
            } else {
                $scope.changeStatus.payloads = { status: null }
                $scope.changeStatus.fields.status.enum = []
            }
        },
        update(contractGas) {
            const comment = `
                <b>AUTOMATIQUE</b> : changement de statut manuel par un admin :
                <b>${contractGas.status}</b> ➔ <b>${$filter('contractStatus')($scope.changeStatus.payloads.status)}</b>`
            return DataAccess.changeContractStatus({
                id_contract: contractGas.id,
                status: $scope.changeStatus.payloads.status,
            }, {}).$promise.then(() => {
                AlertManager.success('Status changé')
                AdminComments.addComment({ object: contractGas.id, comment }).$promise.catch(ErrorCatcher)
                $scope.refreshContract(contractGas)
            }).catch(ErrorCatcher)
        },
    }

    // CATEGORY EDITION
    let refCategories

    $scope.editCategoryFields = {
        newCategory: {
            label: 'Catégorie',
            type: 'select',
            enum: [],
        },
    }

    $scope.refreshCategories = (id_account) =>
        DataAccess.getRefContractCategories({ id_account, energy_type: 'GAS' }).$promise.then((categories) => {
            refCategories = categories
            const catEnum = _.map(categories, (cat) => ({ label: cat.name, value: cat.id }))
            $scope.editCategoryFields.newCategory.enum = catEnum
        }).catch(ErrorCatcher)


    $scope.toggleOnCategoryEditing = function (c) {
        c.newCategory = c.id_category
        $scope.refreshCategories(c.id_account).then(() => {
            c.editCategory = true
        })
    }

    $scope.toggleOffCategoryEditing = (c) => {
        c.editCategory = false
    }

    $scope.updateCategory = (c) =>
        DataAccess.updateContractInfos({ id_contract: c.id }, { id_category: c.newCategory }).$promise.then(() => {
            AlertManager.success('Catégorie mise à jour')
            c.editCategory = false
            c.id_category = c.newCategory
            c.category = _.find(refCategories, { id: c.id_category }) })
        .catch(ErrorCatcher)

    // DL LINK
    $scope.dlInvoice = (invoice, id_account) => {
        return DownloadService.downloadInvoice(invoice.download_link, id_account)
    }
})
